
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M28.9 9.5c-.3-1.2-1.2-2.1-2.4-2.4-2.1-.5-10.5-.5-10.5-.5s-8.4 0-10.5.6c-1.2.3-2.1 1.2-2.4 2.3-.6 2.1-.6 6.5-.6 6.5s0 4.4.6 6.5c.3 1.2 1.2 2.1 2.4 2.4 2.1.5 10.5.5 10.5.5s8.4 0 10.5-.6c1.2-.3 2.1-1.2 2.4-2.4.6-2.1.6-6.5.6-6.5s0-4.3-.6-6.4zM13.3 20v-8l7 4-7 4z"}})])
          )
        }
      }
    